import Ajv from'ajv';import addFormats from'ajv-formats';import ajvErrors from'ajv-errors';const V_COMP = '$comp';
const V_CHILDREN = '$children';
const ACTION_KEY = '$action';
const MODIFIER_KEY = '$modifier';
const PATH_MODIFIERS_KEY = '$pathModifiers';
const LIST_SEMAPHORE = '$isList';
const LIST_ITEM = '$listItem';
/** Main JsonUI list pagination keys (parity). */
const LIST_PAGE = '$page';
const LIST_ITEM_PER_PAGE = '$itemPerPage';
const LIST_LENGTH = '$listLength';
/** Field-level inline validation spec key on a node. */
const V_VALIDATIONS = '$validations';
// Store-name suffixes for parallel trees (errors, touch-state, etc.).
const ERROR_STORE_SUFFIX = '.error';
/** Shadow store for field touched state (aligned with main JsonUI `.touch`). */
const TOUCH_STORE_SUFFIX = '.touch';
const JSON_SEPARATOR = '/';
// Single-root store layout helper.
// All logical stores live under `/storeRoot/{storeName}/...`.
const STORE_ROOT_PATH = '/storeRoot';/**
 * Shared helpers for function handlers.
 */
const isRecord$1 = (value) => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
const hasAnyError$1 = (value) => {
    if (value === null || value === undefined)
        return false;
    if (Array.isArray(value)) {
        return value.some((v) => hasAnyError$1(v));
    }
    if (typeof value === 'object') {
        return Object.values(value).some((v) => hasAnyError$1(v));
    }
    // Any non-null / non-undefined primitive counts as "has error".
    return true;
};
const hasAnyTouched$1 = (value) => {
    if (value === true)
        return true;
    if (value === null || value === undefined)
        return false;
    if (Array.isArray(value)) {
        return value.some((v) => hasAnyTouched$1(v));
    }
    if (typeof value === 'object') {
        return Object.values(value).some((v) => hasAnyTouched$1(v));
    }
    return false;
};
/**
 * Throws if value contains anything that cannot round-trip through JSON:
 * undefined, function, symbol, bigint, NaN, non-finite numbers, or circular references.
 */
const assertJsonCompatible = (value, seen = new WeakSet()) => {
    if (value === null)
        return;
    if (value === undefined)
        throw new Error('undefined is not JSON-compatible');
    const type = typeof value;
    if (type === 'string' || type === 'boolean')
        return;
    if (type === 'number') {
        if (!Number.isFinite(value))
            throw new Error(`Non-finite number is not JSON-compatible: ${value}`);
        return;
    }
    if (type === 'function' || type === 'symbol' || type === 'bigint') {
        throw new Error(`${type} is not JSON-compatible`);
    }
    const obj = value;
    if (seen.has(obj))
        throw new Error('Circular reference is not JSON-compatible');
    seen.add(obj);
    if (Array.isArray(value)) {
        for (const item of value)
            assertJsonCompatible(item, seen);
    }
    else {
        for (const v of Object.values(value))
            assertJsonCompatible(v, seen);
    }
    seen.delete(obj);
};
/**
 * Deep clone helper used by get() so callers cannot mutate the internal store state.
 * Only JSON-compatible values are accepted; functions and other non-JSON types throw.
 */
const cloneDeep = (value) => {
    if (value === null || value === undefined)
        return value;
    const type = typeof value;
    if (type !== 'object') {
        if (type === 'function' || type === 'symbol' || type === 'bigint') {
            throw new Error(`${type} is not JSON-compatible`);
        }
        if (type === 'number' && !Number.isFinite(value)) {
            throw new Error(`Non-finite number is not JSON-compatible: ${value}`);
        }
        return value;
    }
    if (Array.isArray(value)) {
        return value.map((item) => cloneDeep(item));
    }
    const obj = value;
    const result = {};
    for (const key of Object.keys(obj)) {
        result[key] = cloneDeep(obj[key]);
    }
    return result;
};/**
 * Minimal JSON Pointer implementation (RFC 6901).
 * Supports get, set, and path resolution (absolute, relative, ./ ../).
 *
 * Paths and nesting are unbounded: e.g. /a/b/c/0/d/e/1/f is valid;
 * segments can be object keys or array indices (numeric strings).
 */
/**
 * Normalize a path: remove empty segments and trailing/leading slashes.
 * Prevents accidental keys like "" from paths such as "//" or "/a/".
 * Does not decode segments (e.g. ~1 stays so one segment is preserved).
 */
const normalizePath = (pathStr) => {
    if (!pathStr || pathStr === '/')
        return '/';
    const trimmed = pathStr.startsWith('/') ? pathStr.slice(1) : pathStr;
    const segments = trimmed.split(JSON_SEPARATOR).filter((s) => s !== '');
    return segments.length === 0 ? '/' : JSON_SEPARATOR + segments.join(JSON_SEPARATOR);
};
const parsePath = (pathStr) => {
    if (!pathStr || pathStr === '/')
        return [];
    if (!pathStr.startsWith(JSON_SEPARATOR)) {
        throw new Error(`Invalid JSON Pointer path: ${pathStr}`);
    }
    return pathStr.slice(1).split(JSON_SEPARATOR).map(decode);
};
const decode = (segment) => {
    for (let i = 0; i < segment.length; i++) {
        if (segment[i] === '~') {
            const next = segment[i + 1];
            if (next !== '0' && next !== '1') {
                throw new Error(`Invalid JSON Pointer escape in segment: ${segment}`);
            }
            i += 1;
        }
    }
    return segment.replace(/~1/g, '/').replace(/~0/g, '~');
};
const encode = (segment) => {
    return String(segment).replace(/~/g, '~0').replace(/\//g, '~1');
};
const get$1 = (obj, pathStr) => {
    const segments = parsePath(pathStr); // parsePath normalizes, so /a//b/ -> /a/b
    let current = obj;
    for (const seg of segments) {
        if (current == null || typeof current !== 'object')
            return undefined;
        current = current[seg];
    }
    return current;
};
/**
 * Resolve a path against a base path (for relative paths like ./x, ../y).
 * Supports arbitrary depth; excess ".." yields root then appends remaining segments.
 */
const resolvePath = (basePath, relativePath) => {
    if (relativePath.startsWith('/'))
        return normalizePath(relativePath);
    const baseSegments = parsePath(basePath);
    const relSegments = relativePath.split(JSON_SEPARATOR).filter(Boolean);
    for (const seg of relSegments) {
        if (seg === '..') {
            baseSegments.pop();
        }
        else if (seg !== '.') {
            baseSegments.push(decode(seg));
        }
    }
    return JSON_SEPARATOR + baseSegments.map(encode).join(JSON_SEPARATOR);
};/**
 * Tree-shaped state management with multiple stores.
 * Similar to Redux but tailored for JSON UI: per-store trees, JSON Pointer paths.
 *
 * Store paths are unbounded and can be arbitrarily nested (objects and arrays),
 * e.g. /a/b/c/2/d/e/0/f. Logical paths are resolved via resolveStorePath and
 * applied consistently in get/set.
 */
const isTouchOrErrorShadowStore = (storeName) => {
    return storeName.endsWith(TOUCH_STORE_SUFFIX) || storeName.endsWith(ERROR_STORE_SUFFIX);
};
class FormStore {
    constructor() {
        this.state = {};
        this.changeListeners = new Set();
    }
    getState() {
        return cloneDeep(this.state);
    }
    /**
     * Logical JsonUI stores snapshot — same shape as `JsonUI` `defaultValues`:
     * `{ data: {...}, "data.touch": {...}, "data.error": {...} }`.
     * Omits the internal `/storeRoot` wrapper returned by {@link getState}.
     */
    getLogicalStoresMap() {
        const slice = get$1(this.state, STORE_ROOT_PATH);
        if (slice === undefined || slice === null || typeof slice !== 'object' || Array.isArray(slice)) {
            return {};
        }
        return cloneDeep(slice);
    }
    /**
     * Initialise a logical store root without marking fields as touched.
     */
    initializeStore(storeName, value) {
        this.set(storeName, '/', value, false);
    }
    getByPointer(path) {
        const value = get$1(this.state, path);
        return cloneDeep(value);
    }
    setByPointer(path, value) {
        assertJsonCompatible(value);
        this.state = setImmutable(this.state, path, value);
        this.notify();
    }
    /**
     * Convenience helpers that work with logical store names and logical paths,
     * instead of requiring callers to compose `/storeRoot/{storeName}/...`.
     *
     * Store isolation: each storeName (e.g. "data", "data.error", "data.touch") is
     * a distinct store. get/set only read/write that store's subtree;
     * "data.error" cannot access "data" or any other store.
     *
     * When trackTouch is true, set also writes to `${storeName}.touch` at
     * the same logicalPath; path normalization applies (no empty segments).
     */
    set(storeName, logicalPath, value, trackTouch = true, notify = true) {
        const internalPath = makeStorePath(storeName, logicalPath);
        this.setByPointer(internalPath, value);
        if (trackTouch && !isTouchOrErrorShadowStore(storeName)) {
            const touchStoreName = `${storeName}${TOUCH_STORE_SUFFIX}`;
            this.setByPointer(makeStorePath(touchStoreName, logicalPath), true);
        }
        // Notify fine-grained listeners with logical store name + path so
        // JsonUI can re-resolve only components that depend on this slice.
        if (notify) {
            this.notifyChange(storeName, logicalPath);
        }
    }
    get(storeName, logicalPath) {
        const internalPath = makeStorePath(storeName, logicalPath);
        return this.getByPointer(internalPath);
    }
    // Backward-compatible aliases for existing consumers.
    setForStore(storeName, logicalPath, value, trackTouch = true) {
        this.set(storeName, logicalPath, value, trackTouch);
    }
    // Backward-compatible aliases for existing consumers.
    getForStore(storeName, logicalPath) {
        return this.get(storeName, logicalPath);
    }
    notify() {
        // No coarse-grained subscription API is exposed intentionally.
    }
    subscribeChange(listener) {
        this.changeListeners.add(listener);
        return () => this.changeListeners.delete(listener);
    }
    notifyChange(storeName, logicalPath) {
        this.changeListeners.forEach((l) => l(storeName, logicalPath));
    }
}
const makeStorePath = (storeName, path) => {
    if (!storeName || storeName.length === 0) {
        throw new Error('storeName must be a non-empty string');
    }
    const base = `${STORE_ROOT_PATH}/${storeName}`;
    const pointerPath = !path || path === '/' ? '/' : path.startsWith('/') ? path : `/${path}`;
    const normalized = normalizePath(pointerPath);
    if (normalized === '/')
        return base;
    return base + normalized;
};
/**
 * Immutable variant of ptrSet: returns a new root object with the change applied,
 * without mutating the original tree. Only the objects/arrays along the path are
 * shallow-copied; unrelated subtrees are structurally shared for performance.
 */
const setImmutable = (root, pathStr, value) => {
    const segments = parsePath(pathStr);
    if (segments.length === 0)
        return root;
    const originalRoot = root;
    const cloneContainer = (container) => {
        if (Array.isArray(container)) {
            return container.slice();
        }
        if (container && typeof container === 'object') {
            return { ...container };
        }
        return {};
    };
    const setAt = (current, index) => {
        const isLast = index === segments.length - 1;
        const seg = segments[index];
        const container = cloneContainer(current);
        if (isLast) {
            const lastSeg = seg;
            const lastKey = lastSeg === '' || /^\d+$/.test(lastSeg) ? parseInt(lastSeg, 10) : lastSeg;
            if (Array.isArray(container)) {
                container[lastKey] = value;
            }
            else {
                container[lastSeg] = value;
            }
            return { cloned: container, result: container };
        }
        const nextSeg = segments[index + 1];
        const nextKey = nextSeg === '' || /^\d+$/.test(nextSeg) ? parseInt(nextSeg, 10) : nextSeg;
        // Non-last segment: ensure child container exists before descending.
        const keyForChild = seg;
        let next = Array.isArray(container) && /^\d+$/.test(seg) ? container[parseInt(seg, 10)] : container[seg];
        if (next == null ||
            typeof next !== 'object' ||
            (Array.isArray(next) && typeof nextKey === 'string') ||
            (!Array.isArray(next) && typeof nextKey === 'number')) {
            next = typeof nextKey === 'number' ? [] : {};
        }
        const { result: childClone } = setAt(next, index + 1);
        if (Array.isArray(container) && /^\d+$/.test(String(keyForChild))) {
            container[parseInt(String(keyForChild), 10)] = childClone;
        }
        else {
            container[String(keyForChild)] = childClone;
        }
        return { cloned: container, result: container };
    };
    const { result } = setAt(originalRoot, 0);
    return result;
};
/**
 * Resolve a path for a given store, using pathModifiers (from list context) and currentPath for relative paths.
 * - Absolute path: /firstname -> unchanged (then normalized).
 * - Relative path: firstname -> resolved against currentPath (or pathModifiers[storeName] when in list context).
 * - pathModifiers apply per store: only pathModifiers[storeName] is used for that store; "data.error" cannot
 *   access "data" or any other store.
 * Returns a normalized path (no empty segments, no trailing slash).
 */
const resolveStorePath = (pathStr, currentPath, pathModifiers, storeName) => {
    let resolved;
    const modifier = pathModifiers !== undefined && storeName !== undefined && Object.prototype.hasOwnProperty.call(pathModifiers, storeName)
        ? pathModifiers[storeName]
        : undefined;
    if (modifier !== undefined) {
        resolved = resolvePath(modifier.path, pathStr);
    }
    else if (pathStr.startsWith('/')) {
        resolved = pathStr;
    }
    else {
        resolved = resolvePath(currentPath, pathStr);
    }
    return normalizePath(resolved);
};const createSetAction = (formStore) => {
    return async (params, ctx) => {
        const storeName = params.store;
        const path = params.path;
        let value = params.value;
        const jsonataDef = params.jsonataDef;
        if (!storeName || storeName.length === 0)
            return;
        if (typeof jsonataDef === 'string' && jsonataDef) {
            try {
                const jsonata = (await import('jsonata')).default;
                const expr = jsonata(jsonataDef);
                value = await expr.evaluate(value);
            }
            catch {
                value = params.value;
            }
        }
        const logicalPath = resolveStorePath(path, ctx?.currentPath ?? '/', ctx?.pathModifiers, storeName);
        formStore.set(storeName, logicalPath, value);
    };
};const set = (params, ctx) => {
    const setFn = createSetAction(ctx.formStore);
    return setFn(params, ctx);
};const actions = {
    set,
};/**
 * Expands simplified node format into full JSON UI node so components receive
 * value, onChange, error, etc. without the model having to specify every binding.
 *
 * When a node has store + path (non-empty store, string path), we add:
 * - value: { $modifier: 'get', store, path }
 * - onChange: { $action: 'set', store, path }
 * - error / fieldErrors: { $modifier: 'get', store: store + '.error', path }
 * - fieldTouched: { $modifier: 'get', store: store + '.touch', path }
 *
 * The component is unchanged; RenderNode uses the expanded node for prop
 * resolution and the expanded props are passed through normally.
 */
const isSimplifiedNode = (node) => {
    if (typeof node !== 'object' || node === null)
        return false;
    const r = node;
    const store = r.store;
    const path = r.path;
    return typeof store === 'string' && store.length > 0 && typeof path === 'string';
};
/**
 * Returns an expanded node with value, onChange, error, fieldErrors, fieldTouched
 * derived from store + path. Strips store and path from the result so they are
 * not passed as component props.
 * If the node is not simplified, returns the same node reference.
 */
const expandSimplifiedNode = (node) => {
    if (!isSimplifiedNode(node) && node[V_COMP] !== 'SubmitButton') {
        return node;
    }
    const { store, path, ...rest } = node;
    const expanded = {
        ...(node[V_COMP] === 'SubmitButton'
            ? {
                onClick: {
                    [ACTION_KEY]: 'submit',
                },
            }
            : {}),
        ...(isSimplifiedNode(node)
            ? {
                value: {
                    [MODIFIER_KEY]: 'get',
                    store,
                    path,
                },
                onChange: {
                    [ACTION_KEY]: 'set',
                    store,
                    path,
                },
                fieldErrors: {
                    [MODIFIER_KEY]: 'get',
                    store,
                    path,
                    type: 'ERROR',
                },
                fieldTouched: {
                    [MODIFIER_KEY]: 'get',
                    store,
                    path,
                    type: 'TOUCH',
                },
            }
            : {
                //if is not a simplified node, we should add store and path props
                store,
                path,
            }),
        ...rest,
    };
    return expanded;
};const computeListSliceRange = ({ realDataLength, page: pageRaw, itemPerPage: itemPerPageRaw, listLength: listLengthRaw, }) => {
    const coerceNonNegInt = (v, fallback) => {
        if (typeof v === 'number' && Number.isInteger(v) && v >= 0)
            return v;
        return fallback;
    };
    let listLength = coerceNonNegInt(listLengthRaw, realDataLength);
    if (listLengthRaw === undefined) {
        listLength = realDataLength;
    }
    const itemPerPage = coerceNonNegInt(itemPerPageRaw, listLength);
    const page = coerceNonNegInt(pageRaw, 0);
    const offset = page * itemPerPage <= listLength ? page * itemPerPage : 0;
    const end = Math.min(listLength, offset + itemPerPage);
    const indices = [];
    for (let i = offset; i < end; i++)
        indices.push(i);
    return { offset, end, indices };
};const getOwnPathModifiers = (node) => {
    return node[PATH_MODIFIERS_KEY];
};
const mergeEffectivePathModifiers = ({ ownPathModifiers, pathModifiers, currentPath, }) => {
    if (!ownPathModifiers || typeof ownPathModifiers !== 'object') {
        return pathModifiers;
    }
    const merged = {
        ...(pathModifiers ?? {}),
    };
    for (const [storeName, spec] of Object.entries(ownPathModifiers)) {
        if (typeof spec !== 'object')
            continue;
        const rawPath = spec.path;
        if (typeof rawPath !== 'string' || rawPath.length === 0)
            continue;
        const resolved = resolveStorePath(rawPath, currentPath, pathModifiers, storeName);
        merged[storeName] = { path: resolved };
    }
    return merged;
};/** Segment-aware path overlap check (aligned with validation.ts). */
const isPathPrefix$1 = (rulePath, targetPath) => {
    const r = rulePath === '' ? '/' : rulePath;
    const t = targetPath === '' ? '/' : targetPath;
    if (r === '/')
        return true;
    if (t === r)
        return true;
    return t.startsWith(r.endsWith('/') ? r : `${r}/`);
};const hasAnyError = (value) => {
    if (value === null || value === undefined)
        return false;
    if (Array.isArray(value)) {
        return value.some((v) => hasAnyError(v));
    }
    if (typeof value === 'object') {
        return Object.values(value).some((v) => hasAnyError(v));
    }
    return true;
};
const hasAnyTouched = (value) => {
    if (value === true)
        return true;
    if (value === null || value === undefined)
        return false;
    if (Array.isArray(value)) {
        return value.some((v) => hasAnyTouched(v));
    }
    if (typeof value === 'object') {
        return Object.values(value).some((v) => hasAnyTouched(v));
    }
    return false;
};
const createGetModifier = (formStore) => {
    return async (params, ctx) => {
        const storeName = !!params?.store && typeof params.store === 'string' ? params.store : '';
        const path = !!params?.path && typeof params.path === 'string' ? params.path : '/';
        const type = !!params?.type && typeof params.type === 'string' ? params.type : undefined;
        const getBoolean = params?.getBoolean !== false;
        const jsonataDef = params?.jsonataDef;
        if (storeName.length === 0)
            return undefined;
        const resolvedStoreName = type === 'ERROR' ? `${storeName}${ERROR_STORE_SUFFIX}` : type === 'TOUCH' ? `${storeName}${TOUCH_STORE_SUFFIX}` : storeName;
        // Path modifiers are keyed by the logical/base store (e.g. "data"),
        // not by shadow stores like "data.error".
        const logicalPath = resolveStorePath(path, ctx.currentPath, ctx.pathModifiers, storeName);
        let value = formStore.get(resolvedStoreName, logicalPath);
        // For ERROR lookups, leaf-less containers (e.g. { players: [{}] })
        // mean there is no actual validation message in the subtree.
        if (type === 'ERROR' && !hasAnyError(value)) {
            value = undefined;
        }
        // TODO need to test hasAnyTouched and hasAnyError
        if (type === 'TOUCH') {
            value = getBoolean ? hasAnyTouched(value) : value;
        }
        if (jsonataDef && value !== undefined) {
            try {
                const jsonata = (await import('jsonata')).default;
                const expr = jsonata(jsonataDef);
                value = await expr.evaluate(value);
            }
            catch {
                // fallback
            }
        }
        return value;
    };
};/**
 * Resolves $modifier (and nested values) anywhere in the tree.
 * Modifiers can appear at component root (value, onChange, etc.), in nested
 * structures (e.g. style.fontSize, style.base.padding), or in $child* slot content.
 * We recurse into objects and arrays so every occurrence is resolved.
 */
//TODO add unit test to the resolveModifier
async function resolveModifier(value, modifiers, ctx) {
    // If it's a direct modifier object: { $modifier: 'x', ...params }
    if (value != null && typeof value === 'object' && MODIFIER_KEY in value) {
        const { [MODIFIER_KEY]: mod, ...params } = value;
        const resolvedParams = {};
        for (const [k, v] of Object.entries(params)) {
            resolvedParams[k] = await resolveModifier(v, modifiers, ctx);
        }
        const handler = modifiers[mod] ?? (mod === 'get' ? createGetModifier(ctx.formStore) : undefined);
        if (!handler)
            return undefined;
        const result = handler(resolvedParams, ctx);
        return result instanceof Promise ? await result : result;
    }
    // If it's an array, resolve modifiers in each element.
    if (Array.isArray(value)) {
        const resolved = await Promise.all(value.map((item) => resolveModifier(item, modifiers, ctx)));
        return resolved;
    }
    // If it's a plain object without $modifier, traverse its properties
    // so nested fields like www2.bbb or payload.value get resolved.
    if (value != null && typeof value === 'object') {
        const obj = value;
        const entries = Object.entries(obj);
        if (entries.length === 0)
            return value;
        const resolvedObj = {};
        for (const [k, v] of entries) {
            resolvedObj[k] = await resolveModifier(v, modifiers, ctx);
        }
        return resolvedObj;
    }
    // Primitive or null – nothing to do.
    return value;
}/**
 * Style types for the shared style layer (web + React Native).
 * Canonical style is a subset of CSS-like keys that we support and map to both platforms.
 */
/** Default breakpoint width thresholds (min-width in px) */
const DEFAULT_BREAKPOINTS = {
    base: 0,
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
};
/** Order for merging: base first, then xs..xl */
const BREAKPOINT_ORDER = ['base', 'xs', 'sm', 'md', 'lg', 'xl'];/**
 * Resolves canonical or responsive style to platform-specific style (web or React Native).
 * Pure and synchronous; no dependencies.
 */
const isResponsiveStyle = (style) => {
    if (typeof style !== 'object' || Array.isArray(style))
        return false;
    const keys = Object.keys(style);
    return keys.some((k) => BREAKPOINT_ORDER.includes(k));
};
/**
 * Merge responsive style into a single style: base + all breakpoints up to and including current.
 * Mobile-first: current breakpoint index determines how many layers we merge.
 */
const mergeResponsive = (responsive, currentBreakpoint) => {
    const idx = BREAKPOINT_ORDER.indexOf(currentBreakpoint);
    const merged = {};
    for (let i = 0; i <= idx; i++) {
        const key = BREAKPOINT_ORDER[i];
        const block = responsive[key];
        if (block && typeof block === 'object' && !Array.isArray(block)) {
            Object.assign(merged, block);
        }
    }
    return merged;
};
/**
 * Parse "1px solid #ccc" or similar border shorthand into parts.
 */
const parseBorder = (value) => {
    const parts = value.trim().split(/\s+/);
    const result = {};
    for (const p of parts) {
        if (/^\d+(\.\d+)?(px)?$/.test(p)) {
            result.width = parseFloat(p);
        }
        else if (['solid', 'dashed', 'dotted', 'none'].includes(p)) {
            result.style = p;
        }
        else if (p.startsWith('#') || p.startsWith('rgb')) {
            result.color = p;
        }
    }
    return result;
};
/**
 * Convert canonical style to React Native-compatible style.
 * - border shorthand -> borderWidth, borderColor, borderStyle
 * - cursor is not supported on RN, omit
 * - numeric values kept as-is where RN expects numbers
 */
const toNativeStyle = (canonical) => {
    const out = {};
    for (const [key, value] of Object.entries(canonical)) {
        if (value === undefined)
            continue;
        if (key === 'cursor')
            continue; // not supported on RN
        if (key === 'border' && typeof value === 'string') {
            const { width, style, color } = parseBorder(value);
            if (width !== undefined)
                out.borderWidth = width;
            if (style)
                out.borderStyle = style;
            if (color)
                out.borderColor = color;
            continue;
        }
        if (key === 'borderRadius' && typeof value === 'number') {
            out.borderRadius = value;
            continue;
        }
        if ((key === 'borderTop' || key === 'borderBottom' || key === 'borderLeft' || key === 'borderRight') && typeof value === 'string') {
            const { width, style, color } = parseBorder(value);
            if (width !== undefined)
                out[`${key}Width`] = width;
            if (style)
                out[`${key}Style`] = style;
            if (color)
                out[`${key}Color`] = color;
            continue;
        }
        out[key] = value;
    }
    return out;
};
/**
 * Length-like style keys that need a unit (px) when the value is a bare number
 * or numeric string (e.g. from a store/modifier like sliderValue).
 */
const LENGTH_KEYS = new Set([
    'fontSize',
    'width',
    'height',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'top',
    'right',
    'bottom',
    'left',
    'gap',
]);
const ensureLengthUnit = (key, value) => {
    if (value === undefined)
        return value;
    if (!LENGTH_KEYS.has(key))
        return value;
    if (typeof value === 'number')
        return `${value}px`;
    if (typeof value === 'string' && /^\d+(\.\d+)?$/.test(value.trim())) {
        return `${value.trim()}px`;
    }
    return value;
};
/**
 * Web: pass through with minimal changes. Normalize length props (e.g. fontSize)
 * so numeric or numeric-string values get "px" and the browser applies them.
 */
const toWebStyle = (canonical) => {
    const out = {};
    for (const [key, value] of Object.entries(canonical)) {
        out[key] = ensureLengthUnit(key, value);
    }
    return out;
};
/**
 * Resolve style input (canonical or responsive) to platform-specific style.
 * - If style is responsive (has base/xs/sm/md/lg/xl), merge up to current breakpoint, then resolve.
 * - If no breakpoint is provided for a responsive style, only "base" is used.
 */
const resolveStyle = (style, options) => {
    if (!style || typeof style !== 'object')
        return undefined;
    let canonical;
    if (isResponsiveStyle(style)) {
        const breakpoint = options.breakpoint ?? 'base';
        canonical = mergeResponsive(style, breakpoint);
    }
    else {
        canonical = style;
    }
    if (Object.keys(canonical).length === 0)
        return undefined;
    return options.platform === 'native' ? toNativeStyle(canonical) : toWebStyle(canonical);
};let inlineAjv = null;
const getInlineAjv = () => {
    if (!inlineAjv) {
        // TODO why it's no strict?
        inlineAjv = new Ajv({ allErrors: true, strict: false });
        addFormats(inlineAjv);
        ajvErrors(inlineAjv);
    }
    return inlineAjv;
};
const stringifyValidationError = (error) => {
    if (typeof error === 'string')
        return error;
    if (typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string') {
        return error.message;
    }
    try {
        return String(error);
    }
    catch {
        return 'error';
    }
};
const buildValidationRegistry = (rules) => {
    const registry = {};
    if (!Array.isArray(rules) || rules.length === 0)
        return registry;
    const ajv = new Ajv({ allErrors: true, strict: false });
    // TODO: check test how looks like in jsonui
    addFormats(ajv);
    ajvErrors(ajv);
    for (const rule of rules) {
        if (rule.schema === undefined || rule.schema === null || !rule.store || !rule.path)
            continue;
        const schema = rule.schema;
        const store = rule.store;
        const path = rule.path;
        if (schema === undefined || schema === null)
            continue;
        if (typeof store !== 'string' || store.length === 0)
            continue;
        if (typeof path !== 'string' || path.length === 0)
            continue;
        const validate = ajv.compile(schema);
        const byStore = registry[store] ?? (registry[store] = {});
        const list = byStore[path] ?? (byStore[path] = []);
        list.push(validate);
    }
    return registry;
};
/**
 * Evaluate a single inline validation spec and return its error message, if any.
 * Does not write to the error store.
 */
const evaluateInlineValidation = async (spec, value, modifiers, ctx) => {
    if (spec.schema != null) {
        const ajv = getInlineAjv();
        const validate = ajv.compile(spec.schema);
        const messages = [];
        const valid = validate(value);
        if (!valid && validate.errors) {
            for (const err of validate.errors) {
                if (err.message)
                    messages.push(err.message);
            }
        }
        return messages.length > 0 ? messages.join('; ') : null;
    }
    if (spec.jsonataDef != null) {
        let result;
        try {
            const jsonata = (await import('jsonata')).default;
            const expr = jsonata(spec.jsonataDef);
            result = await expr.evaluate(value);
        }
        catch (e) {
            result = stringifyValidationError(e);
        }
        const hasError = result !== null && result !== undefined && result !== '' && result !== true;
        if (!hasError)
            return null;
        return spec.errorMessage ? String(await resolveModifier(spec.errorMessage, modifiers, ctx)) : String(result);
    }
    return null;
};
const writeInlineValidationError = (formStore, errorStoreName, componentLogicalPath, newError, notify) => {
    const currentError = formStore.get(errorStoreName, componentLogicalPath);
    if ((currentError ?? null) === newError)
        return;
    formStore.set(errorStoreName, componentLogicalPath, newError, false, notify);
};
/**
 * Run all inline validation specs for a field, aggregate messages, and write once.
 */
const runInlineValidations = async (specs, componentStoreName, componentLogicalPath, modifiers, ctx, options) => {
    const { formStore } = ctx;
    const errorStoreName = `${componentStoreName}${ERROR_STORE_SUFFIX}`;
    const value = formStore.get(componentStoreName, componentLogicalPath);
    const notify = options?.notify !== false;
    const messages = [];
    for (const spec of specs) {
        if (typeof spec !== 'object')
            continue;
        const message = await evaluateInlineValidation(spec, value, modifiers, ctx);
        if (message)
            messages.push(message);
    }
    const newError = messages.length > 0 ? messages.join('; ') : null;
    writeInlineValidationError(formStore, errorStoreName, componentLogicalPath, newError, notify);
};
// Runs all validators whose rule path matches the changed path prefix for the given store.
// Aggregates current validation messages and writes or clears them in the matching .error store paths.
const runValidationsForPath = (registry, formStore, storeName, path) => {
    const storeValidators = registry[storeName];
    // No validators registered for this store at all
    if (!storeValidators) {
        return;
    }
    const errorStoreName = `${storeName}${ERROR_STORE_SUFFIX}`;
    // Collect new error messages per *concrete* target path (e.g. '/players/0/score').
    const perPathMessages = {};
    const affectedErrorPaths = new Set();
    // Include any existing error leaf paths under matching rule paths so we can clear
    // them if they become valid.
    const collectExistingPaths = (basePath, value) => {
        if (value == null)
            return;
        if (typeof value !== 'object') {
            affectedErrorPaths.add(basePath);
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((v, i) => {
                collectExistingPaths(`${basePath}/${i}`, v);
            });
            return;
        }
        for (const [k, v] of Object.entries(value)) {
            const encodedKey = k.replace(/~/g, '~0').replace(/\//g, '~1');
            collectExistingPaths(basePath === '/' ? `/${encodedKey}` : `${basePath}/${encodedKey}`, v);
        }
    };
    // Run all validators whose rule path is a prefix of the affected path.
    // Example: action path '/a/b/c' should trigger validators registered for
    // '/', '/a', '/a/b', and '/a/b/c'.
    for (const [rulePath, validators] of Object.entries(storeValidators)) {
        if (!Array.isArray(validators) || validators.length === 0)
            continue;
        if (!isPathPrefix(rulePath, path))
            continue;
        // Track existing error paths under this rule so we can clear them.
        const existingSubtree = formStore.get(errorStoreName, rulePath);
        if (existingSubtree !== undefined) {
            collectExistingPaths(rulePath === '' ? '/' : rulePath, existingSubtree);
        }
        const valueAtRulePath = formStore.get(storeName, rulePath);
        for (const validate of validators) {
            const valid = validate(valueAtRulePath);
            if (!valid && validate.errors) {
                for (const err of validate.errors) {
                    if (!err.message)
                        continue;
                    const instancePath = typeof err.instancePath === 'string' ? err.instancePath : '';
                    // instancePath is relative to rulePath, e.g. '/0/score'
                    let targetPath;
                    if (rulePath === '' || rulePath === '/') {
                        // When instancePath is empty, the error is at the root of the validated object.
                        // Store at '/~1' (JSON Pointer for key '/') to avoid overwriting the entire error store.
                        targetPath = instancePath && instancePath.length > 0 ? instancePath : '/~1';
                    }
                    else {
                        targetPath = instancePath && instancePath.length > 0 ? `${rulePath}${instancePath}` : rulePath;
                    }
                    const list = perPathMessages[targetPath] ?? (perPathMessages[targetPath] = []);
                    list.push(err.message);
                    affectedErrorPaths.add(targetPath);
                }
            }
        }
    }
    // Apply updates for all affected error paths (both existing and new).
    for (const targetPath of affectedErrorPaths) {
        const messages = perPathMessages[targetPath] ?? [];
        const newError = messages.length > 0 ? messages.join('; ') : null;
        const currentError = formStore.get(errorStoreName, targetPath);
        if ((currentError ?? null) === newError)
            continue;
        formStore.set(errorStoreName, targetPath, newError, false);
    }
};
/** Match whole segments only; works for paths of any depth (e.g. /a/b/0/c). */
const isPathPrefix = (rulePath, targetPath) => {
    const r = rulePath === '' ? '/' : rulePath;
    const t = targetPath === '' ? '/' : targetPath;
    if (r === '/')
        return true;
    if (t === r)
        return true;
    return t.startsWith(r.endsWith('/') ? r : `${r}/`);
};/**
 * Recursively walks a node's props value tree and collects all store path dependencies
 * introduced by `$modifier: 'get'` entries. For each `get` modifier found, it resolves
 * the logical store path (accounting for path modifiers and ERROR/TOUCH type variants)
 * and appends it to the `deps` array. Nodes with a `$comp` key are skipped to avoid
 * descending into nested component definitions.
 */
const collectGetModifierDependencies = (val, currentPath, deps, effectivePathModifiers) => {
    if (val && typeof val === 'object' && !Array.isArray(val) && V_COMP in val) {
        return;
    }
    if (val && typeof val === 'object' && !Array.isArray(val) && MODIFIER_KEY in val && val[MODIFIER_KEY] === 'get') {
        const storeName = val.store;
        const type = val.type;
        const path = val.path;
        const alteredStoreName = type === 'ERROR' ? `${storeName ?? ''}${ERROR_STORE_SUFFIX}` : type === 'TOUCH' ? `${storeName ?? ''}${TOUCH_STORE_SUFFIX}` : storeName;
        if (storeName && alteredStoreName) {
            if (typeof path === 'string' && path) {
                const logicalPath = resolveStorePath(path, currentPath, effectivePathModifiers, storeName);
                deps.push({ store: alteredStoreName, path: logicalPath });
            }
            else {
                deps.push({ store: alteredStoreName, path: '/' });
            }
        }
        return;
    }
    if (Array.isArray(val)) {
        val.forEach((v) => collectGetModifierDependencies(v, currentPath, deps, effectivePathModifiers));
        return;
    }
    if (val && typeof val === 'object') {
        for (const v of Object.values(val)) {
            collectGetModifierDependencies(v, currentPath, deps, effectivePathModifiers);
        }
    }
};const isRecord = (value) => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
const runValidationSpecsFromNode = async (node, modifiers, ctx, componentStoreName, componentLogicalPath) => {
    const rawValidation = isRecord(node) ? node[V_VALIDATIONS] : undefined;
    if (!rawValidation || !Array.isArray(rawValidation) || rawValidation.length === 0)
        return;
    if (!componentStoreName || componentLogicalPath == null)
        return;
    const specs = rawValidation.filter((item) => item !== null && typeof item === 'object');
    if (specs.length === 0)
        return;
    // Silent write: fieldErrors are resolved in the same pass right after validation.
    await runInlineValidations(specs, componentStoreName, componentLogicalPath, modifiers, ctx, { notify: false });
};
const runRenderNodeResolution = async ({ node, modifiers, ctx, currentPath, effectivePathModifiers, stylePlatform, styleBreakpoint, componentStore, componentPath, skipInlineValidation = false, }) => {
    const props = {};
    const deps = [];
    const resolvedSlots = {};
    const nodeEntries = isRecord(node) ? Object.entries(node) : [];
    const resolvedComponentPath = componentStore && componentPath != null ? resolveStorePath(componentPath, currentPath, effectivePathModifiers, componentStore) : undefined;
    if (!skipInlineValidation) {
        await runValidationSpecsFromNode(node, modifiers, ctx, componentStore, resolvedComponentPath);
    }
    for (const [key, value] of nodeEntries) {
        if (key.startsWith('$child') || !key.startsWith('$')) {
            collectGetModifierDependencies(value, currentPath, deps, effectivePathModifiers);
            if (key.startsWith('$child')) {
                resolvedSlots[key] = await resolveModifier(value, modifiers, ctx);
            }
            else if (!key.startsWith('$')) {
                props[key] = await resolveModifier(value, modifiers, ctx);
            }
        }
    }
    if (props.style != null) {
        if (typeof props.style !== 'object' || Array.isArray(props.style)) {
            delete props.style;
        }
        else {
            const resolved = resolveStyle(props.style, {
                platform: stylePlatform,
                breakpoint: styleBreakpoint,
            });
            props.style = resolved ?? props.style;
        }
    }
    return {
        state: { props, resolvedSlots },
        deps,
    };
};const resolveAction = (value, actions, modifiers, ctx) => {
    if (value != null && typeof value === 'object' && ACTION_KEY in value) {
        const { [ACTION_KEY]: actionName, ...params } = value;
        const hasExplicitValue = Object.prototype.hasOwnProperty.call(value, 'value');
        // Extract modifiers from action ctx.
        const { componentProps, validators, ...modifierCtx } = ctx;
        let handler = actions[actionName];
        if (!handler && actionName === 'set') {
            handler = createSetAction(ctx.formStore);
        }
        if (!handler)
            return undefined;
        return async (e) => {
            // TODO: research, why componentProps need
            const safeComponentProps = typeof componentProps === 'object' ? componentProps : {};
            const resolvedParams = { ...safeComponentProps, ...params };
            // Case 1: value from event (input onChange) – only when the model
            // did NOT define a value explicitly.
            if (!hasExplicitValue && e != null && typeof e === 'object' && 'target' in e) {
                const target = e.target;
                if (target?.value !== undefined)
                    resolvedParams.value = target.value;
            }
            // Cases 2 & 3: static JSON value or nested $modifier value – both
            // flow through resolveModifier below and are preserved.
            for (const [k, v] of Object.entries(resolvedParams)) {
                resolvedParams[k] = await resolveModifier(v, modifiers, modifierCtx);
            }
            const result = handler(resolvedParams, ctx);
            if (result instanceof Promise)
                await result;
            // Run validations for this store/path if configured
            const storeName = typeof resolvedParams.store === 'string' ? resolvedParams.store : undefined;
            const rawPath = typeof resolvedParams.path === 'string' ? resolvedParams.path : undefined;
            if (validators && storeName && rawPath) {
                // Resolve to logical path so validations work with lists, pathModifiers,
                // and relative paths (e.g. "score" inside /players/0).
                const logicalPath = resolveStorePath(rawPath, ctx.currentPath, ctx.pathModifiers, storeName);
                runValidationsForPath(validators, ctx.formStore, storeName, logicalPath);
            }
        };
    }
    return undefined;
};const get = (params, ctx) => {
    const getFn = createGetModifier(ctx.formStore);
    return getFn(params, ctx);
};async function jsonata(params) {
    const { jsonataDef, ...input } = params;
    if (typeof jsonataDef !== 'string' || !jsonataDef)
        return undefined;
    try {
        const jsonata = (await import('jsonata')).default;
        const expr = jsonata(jsonataDef);
        // Evaluate with the remaining params (e.g. { error, touched }) as input.
        return await expr.evaluate(input);
    }
    catch {
        // On any jsonata error, fall back to undefined so UI doesn't break.
        return undefined;
    }
}const isNotTouchedOrHasError = (params) => {
    const { error, touched } = params;
    const hasError = hasAnyError$1(error);
    const isTouched = hasAnyTouched$1(touched);
    return !isTouched || hasError;
};/**
 * Translation function: looks up key in ctx.translations using active language.
 */
const t = (params, ctx) => {
    const key = params.key;
    if (!key)
        return undefined;
    const translations = ctx.translations ?? {};
    const langParam = params.lang;
    const baseLang = ctx.defaultLanguage || 'en';
    const activeLang = langParam || ctx.activeLanguage || baseLang;
    const entry = translations[key];
    // If we're in the base language, or there is no translation table
    // for this key, just return the key as-is (baseline text).
    if (activeLang === baseLang || entry === undefined)
        return key;
    // Otherwise, use the requested language if available, falling back to key.
    return entry[activeLang] ?? key;
};const modifiers = {
    get,
    jsonata,
    isNotTouchedOrHasError,
    t,
};export{ACTION_KEY,BREAKPOINT_ORDER,DEFAULT_BREAKPOINTS,ERROR_STORE_SUFFIX,FormStore,LIST_ITEM,LIST_ITEM_PER_PAGE,LIST_LENGTH,LIST_PAGE,LIST_SEMAPHORE,MODIFIER_KEY,PATH_MODIFIERS_KEY,TOUCH_STORE_SUFFIX,V_CHILDREN,V_COMP,V_VALIDATIONS,actions,buildValidationRegistry,computeListSliceRange,expandSimplifiedNode,getOwnPathModifiers,isPathPrefix$1 as isPathPrefix,isRecord$1 as isRecord,mergeEffectivePathModifiers,modifiers,normalizePath,resolveAction,resolveStorePath,runRenderNodeResolution};//# sourceMappingURL=index.js.map
